import { render } from "./leftArrow.vue?vue&type=template&id=9dc3284e"
import script from "./leftArrow.vue?vue&type=script&lang=js"
export * from "./leftArrow.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__